import type { FC, ReactNode } from "react";

type Props = {
  children: ReactNode;
};
const Time: FC<Props> = (props) => {
  const { children } = props;

  return <div className="time">{children}</div>;
};

export default Time;
